module.exports = __webpack_public_path__ + "static/media/csv_up_hover.58555c26.svg";